(() => {
  if (customElements.get('lp-product-badges')) return;
  customElements.define('lp-product-badges', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form[data-js-product-form]');
      this.list = this.querySelector('ul');
      this.regular = this.querySelector('template');
      try { this.product = JSON.parse(this.form?.querySelector('[data-js-product-json]')?.textContent || '{}'); } catch (_) { this.product = {}; }
      this.updatePrice = () => {
        const id = Number(this.form?.querySelector('[name="id"]')?.value);
        const variant = this.product.variants?.find(item => Number(item.id) === id) || this.currentVariant;
        const price = Number(variant?.price);
        const compare = Number(variant?.compare_at_price);
        const label = compare > price && compare > 0 ? '-' + Math.round((compare - price) * 100 / compare) + '%' : '';
        this.form?.querySelectorAll('[data-price-discount-value]').forEach(element => {
          if (element.textContent !== label) element.textContent = label;
        });
      };
      this.onVariant = ({ currentVariant }) => {
        this.currentVariant = currentVariant;
        const price = Number(currentVariant?.price);
        const compare = Number(currentVariant?.compare_at_price);
        this.list.replaceChildren();
        if (compare > price && compare > 0) {
          const badge = document.createElement('li');
          badge.className = 'badge badge--primary lp-sale-badge';
          badge.textContent = '-' + Math.round((compare - price) * 100 / compare) + '% ' + this.dataset.sale;
          this.list.append(badge);
        } else {
          this.list.append(this.regular.content.cloneNode(true));
        }
        this.list.hidden = !this.list.children.length;
        queueMicrotask(this.updatePrice);
      };
      this.observer = new MutationObserver(this.updatePrice);
      this.form?.querySelectorAll('.js-price').forEach(element => this.observer.observe(element, { childList: true, subtree: true }));
      this.bind = () => {
        if (this.bus || !this.form || !window.themeCore?.EventBus) return;
        this.bus = window.themeCore.EventBus;
        this.event = 'form:' + this.form.getAttribute('id') + ':change-variant';
        this.bus.listen(this.event, this.onVariant);
      };
      this.bind();
      this.updatePrice();
      document.addEventListener('DOMContentLoaded', this.bind, { once: true });
      window.addEventListener('load', this.bind, { once: true });
    }
    disconnectedCallback() {
      this.bus?.remove(this.event, this.onVariant);
      this.bus = null;
      this.observer?.disconnect();
      document.removeEventListener('DOMContentLoaded', this.bind);
      window.removeEventListener('load', this.bind);
    }
  });
})();

